<template>
    <div>
        <v-text-field
            v-model="code"
            :label="label"
            :loading="loading"
            outlined
            dense
            :readonly="isEditable ? readonly : true"
            :color="inputColor"
            :background-color="backgroundColor"
            :rules="rules"
            hide-details="auto"
            :append-icon="load ? 'mdi-reload' : null"
            @click:append="getCode"
        ></v-text-field>

        <input type="hidden">
    </div>
</template>

<script>
import useSharedData from "@/use/SharedData.js";
import {onMounted, ref, watch} from "vue";
import axios from "axios";

export default {
    name: "WCodeGeneration",
    props: {
        value: String,
        entity: String,
        load: Boolean,
        readonly: Boolean,
        label: String,
        workerCode: String,
        rules: Array,
    },
    setup(props, {emit}) {

        const {loading, inputColor, backgroundColor} = useSharedData();

        const code = ref(null);

        function getCode() {
            loading.value = true;
            axios.get(`/codifications/entity/${props.entity}`).then(response => {
                code.value = response.data;
                emit('input', code.value);
            }).finally(() => {
                loading.value = false;
            });
        }

        const isEditable = ref(false);
        const loadingEditable = ref(false);

        function checkEditable() {
            loadingEditable.value = true;
            axios.get(`/codifications/isEditable/${props.entity}`).then(response => {
                isEditable.value = response.data;
            }).finally(() => {
                loadingEditable.value = false;
            });
        }


        watch(() => props.value, () => {
            if (!props.load) {
                code.value = props.value;
            }
        }, {immediate: true});

        watch(() => code.value, () => {
            emit("input", code.value);
        });

        onMounted(() => {
            checkEditable();
        });

        watch(() => props.load, () => {
            if (props.load) {
                getCode();
            }
        }, {immediate: true});

        return {
            loading,
            code,
            isEditable,
            loadingEditable,
            inputColor,
            backgroundColor,
            getCode,
        }
    }
}
</script>

<style scoped>

</style>